'use client'

import { Button, useDevice } from '@lune-fe/lune-ui-lib'
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import Image from 'next/image'
import { useRouter } from 'next/navigation'
import { FC, ReactNode } from 'react'

const CTATile: FC<{
    backgroundImageUrl: string
    imageAlt: string
    description: ReactNode
    button: {
        label: string
        href: string
    }
}> = ({ backgroundImageUrl, imageAlt, description, button }) => {
    const { mdScreen } = useDevice()
    const router = useRouter()

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                flexDirection: 'column',
                height: '640px',
                width: '100%',
                pt: 6,
                pb: 6,
                pr: 3,
                pl: 3,
                position: 'relative',
                overflow: 'hidden',
                borderRadius: '32px',
                img: {
                    position: 'absolute',
                    top: 0,
                    width: 'auto',
                    height: '100%',
                    zIndex: -1,
                    margin: 'auto',
                },
                cursor: 'pointer',
            }}
            onClick={() => {
                router.push(button.href)
            }}
        >
            <Image src={backgroundImageUrl} width={1600} height={1280} alt={imageAlt} />
            <Text
                sx={{
                    color: 'white',
                    textAlign: 'center',
                }}
                variant={mdScreen ? `body2` : `body1`}
            >
                {description}
            </Text>
            <Button
                sx={{ mt: 4 }}
                variant={'contained'}
                light={true}
                leftIcon={<ArrowCircleRightIcon />}
                onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    router.push(button.href)
                }}
            >
                {button.label}
            </Button>
        </Box>
    )
}

export default CTATile
